import script from "./CyanUpdates.vue?vue&type=script&setup=true&lang=js"
export * from "./CyanUpdates.vue?vue&type=script&setup=true&lang=js"

import "./CyanUpdates.vue?vue&type=style&index=0&id=1bd2c092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd2c092"]])

export default __exports__